import type { FaireProductEntity } from "../../entity_types/product";

export const p_q3eb3rsu83: FaireProductEntity = {
  token: "p_q3eb3rsu83",
  type: "product",
  name: "Yuzu Citrus Beeswax Lip Balm Display – 24-Count",
  brandToken: "b_4g08uuakiy",
  brandName: "Portland Bee Balm",
  imageUrl:
    "https://cdn.faire.com/fastly/fde72fd36f4b6195510b3cc7731383f3390c4142dd3a896e88b61c8c671552f9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07501633794b0fc9676ee64a157d1e6ae3fc41b01403ff558b926061eb567070.png",
    "https://cdn.faire.com/fastly/ad81953ec08f03c661dfa23107acd6c97774b852da6fe9d1c5a41b049019886d.jpeg",
    "https://cdn.faire.com/fastly/bae9b777367486dc12d8f05087d7680a30641ca2aecb0713c0a7f7acde940033.jpeg",
    "https://cdn.faire.com/fastly/32433901c71c6abea6f07a5ee31c100f2986926cf0381461979cee0412fa04d4.png",
    "https://cdn.faire.com/fastly/04803ec6cb83bded2db60c0e5a157e594e78bb79f5270f33eca4667607a79711.png",
    "https://cdn.faire.com/fastly/71ac98b553165cb7efa79a41b6b0159d4b315f4a3903e7ce1ad3a26573d40baf.jpeg",
    "https://cdn.faire.com/fastly/3f6f20d69915e1cf2d9f323e8eca30705becec23f01fdfcadf3b92c0d9161497.jpeg",
  ],
  priceDollars: 2,
  description:
    "Portland Bee Balm’s Yuzu Citrus Beeswax Lip Balm Display is handcrafted with Pacific Northwest beeswax, organic extra virgin coconut oil, organic olive oil, and yuzu absolute imported from Japan. This bright, refreshing balm delivers smooth, long-lasting moisture with a clean citrus finish. Made with only four simple ingredients, it appeals to customers seeking natural lip care free from synthetic additives.\n\nYuzu is one of our most uplifting and unique varieties, offering retailers a standout option with strong sell-through in boutiques, wellness shops, spas, clean beauty retailers, gift stores, travel markets, and seasonal assortments. The 24-count display arrives retail-ready and is easy to merchandise at checkout or in wellness-focused sections.\n\nCrafted with locally sourced Pacific Northwest beeswax, this balm reflects Portland Bee Balm’s commitment to sustainability, simplicity, and quality craftsmanship.\n\nYuzu lip balm, citrus lip balm, natural lip care, beeswax balm, clean beauty, PNW made, boutique skincare, spa retail, giftable lip balm, 24-count display",
  tags: [],
  msrpDollars: 3.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:20:50.283Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
